import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicioCreateComponent } from './servicio-create/servicio-create.component';
import { ServicioIndexComponent } from './servicio-index/servicio-index.component';
import { ServicioViewComponent } from './servicio-view/servicio-view.component';
import { ServicioUpdateComponent } from './servicio-update/servicio-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxMaskModule } from 'ngx-mask';

const routes: Routes = [
  { path: 'index', component: ServicioIndexComponent},
  { path: '', redirectTo: 'index', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    ServicioCreateComponent,
    ServicioIndexComponent,
    ServicioViewComponent,
    ServicioUpdateComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgxKuvUtilsModule,
    NgbModalModule,
    NgbNavModule,
    NgxKuvToolsModule,
    NgxMaskModule,
    NgSelectModule
  ]
})
export class ServicioModule { }
